import * as Yup from 'yup'

export const PersonalInfoSchema = Yup.object().shape({
    city: Yup.object()
        .typeError('errors.empty_field')
        .test('city-object', 'errors.empty_field', (city) => !!(city.value && city.label))
        .required('errors.empty_field'),
    mobile_number: Yup.string().typeError('errors.empty_field').required('errors.empty_field'),
})
